// extracted by mini-css-extract-plugin
export default {"color1":"#41B9FA","color2":"#005ECC","color3":"#7600D3","color4":"#BE41D2","color5":"#FC5AEC","color6":"#FD5AA7","colorNoData":"#28292c"};